'use server';

import { z } from 'zod';
import { headers } from 'next/headers';
import { rateLimit, getClientKey } from '@/lib/rate-limit';
import { isEmailConfigured, getEmailConfig } from '@/lib/env';
import nodemailer from 'nodemailer';

const ContactSchema = z.object({
  name: z.string().min(1).max(80),
  email: z.string().email().max(254),
  message: z.string().min(10).max(4000),
});

export async function submitContactAction(prevState, formData) {
  const headersList = await headers();
  const clientKey = getClientKey(headersList);
  const limited = rateLimit(`contact:${clientKey}`, { max: 3, windowMs: 60 * 60 * 1000 });
  if (!limited.allowed) return { error: 'Too many messages. Try again later.' };

  const parsed = ContactSchema.safeParse(Object.fromEntries(formData));
  if (!parsed.success) return { error: 'Invalid input.' };

  if (!isEmailConfigured()) {
    return { error: 'Email is not configured on this server. Please try again later.' };
  }

  try {
    const config = getEmailConfig();
    const transporter = nodemailer.createTransport({
      host: config.host,
      port: config.port,
      secure: config.secure,
      auth: { user: config.user, pass: config.pass },
    });
    await transporter.sendMail({
      from: config.from,
      to: 'support@typingwhiz.com',
      replyTo: parsed.data.email,
      subject: `Contact form: ${parsed.data.name}`,
      text: `From: ${parsed.data.name} <${parsed.data.email}>\n\n${parsed.data.message}`,
    });
    return { success: 'Message sent. We will respond by email.' };
  } catch (e) {
    console.error('Contact email failed:', e.message);
    return { error: 'Could not send the message. Please try again later.' };
  }
}